import { createAsyncSelectors } from '@lib/selectors';

// Initiative Jira Issues
export const getInitiativeJiraIssuesSelector = createAsyncSelectors((state) => state.integrations.jira.initiatives.get);
